import React from "react";
import * as styles from "../styles/imageDetailCard.module.css";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { Icon } from "@iconify/react";


export default function ImageDetailCard({
  title,
  description,
  image,
  linkTo,
  buttonText,
}) {
  return (
    <div className={`${styles.card} card`}>
      <div className={styles.cardImageBox}>
        <GatsbyImage
          image={image}
          alt={title}
          className={`${styles.cardImage} img-fluid`}
        />
      </div>
      <div className={`${styles.cardBody} card-body`}>
        <h5 className={styles.cardTitle}>
          <Link to={linkTo}>{title}</Link>
        </h5>
        <p className={styles.cardText}>{description}</p>
        <div className={styles.readMore}>
          <Link to={linkTo}>
            <Icon icon="cil:arrow-right" />
            {buttonText}
          </Link>
        </div>
      </div>
    </div>
  );
}
